<template>
  <div id="app-index">
    <home-head></home-head>
    <home-nav></home-nav>
    <div class="login-box">
      <div class="login">
        <div class="login-top">
          <ul>
            <li class="active">{{forgetPwd?"忘记密码":"机构登录"}}</li>
          </ul>
        </div>
        <div v-if="!forgetPwd">
          <div class="login-bottom">
            <div class="phone-box">
              <input
                type="text"
                placeholder="手机号码"
                onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                v-model.trim="unitData.phone"
              />
            </div>
            <div class="input-box" style="padding-left:15px">
              <input
                type="password"
                placeholder="请输入密码"
                v-model.trim="unitData.password"
                onkeyup="this.value=this.value.replace(/(^\s+)|(\s+$)/g,'');"
                @keyup.enter="unitLogin"
              />
            </div>
          </div>
          <div class="btn-box">
            <button @click="unitLogin">登录</button>

            <span
              style="float: left;margin-top: 20px;color:#c30d23;cursor: pointer;"
              v-if="!forgetPwd"
              @click="forgetPwd = true"
            >忘记密码？</span>
            <router-link
              to="/unitRegister"
              style="text-align: right;float: right;margin-top: 20px;color:#c30d23"
            >机构注册</router-link>
          </div>
        </div>

        <div v-if="forgetPwd" class="big-password">
          <div class="password-box">
            <div class="phone-box">
              <span>+86</span>
              <input
                type="text"
                placeholder="手机号码"
                onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                v-model.trim="forgetData.phone"
              />
            </div>
            <div class="input-box">
              <input
                type="text"
                placeholder="获取验证码"
                onkeyup="this.value=this.value.replace(/[^\d]/g,'');"
                v-model.trim="forgetData.code"
              />
              <button :disabled="disabledCode" @click="checkUser">{{codeText}}</button>
            </div>

            <div class="phone-box">
              <input
                type="password"
                placeholder="新密码"
                onkeyup="this.value=this.value.replace(/(^\s+)|(\s+$)/g,'');"
                v-model.trim="forgetData.password"
              />
            </div>

            <div class="phone-box">
              <input
                type="password"
                placeholder="确认密码"
                onkeyup="this.value=this.value.replace(/(^\s+)|(\s+$)/g,'');"
                v-model.trim="forgetData.password_two"
              />
            </div>
          </div>
          <div class="btn-box">
            <button @click="setNewPwd">确认修改</button>
            <span
              style="float: right;margin-top: 20px;color:#c30d23;cursor: pointer;"
              @click="backLogin"
            >返回登录</span>
          </div>
        </div>
      </div>
    </div>
    <foot></foot>
  </div>
</template>
<script>
import animate from "animate.css";
import homeHead from "../Public/head";
import homeNav from "../Public/nav";
import foot from "../Public/foot";
export default {
  components: {
    homeHead,
    homeNav,
    foot,
  },
  data() {
    return {
      loginId: 2,
      forgetPwd: false,
      userData: {},
      unitData: {},
      forgetData: {
        password: null,
        password_two: null,
      },
      codeText: "获取验证码",
      disabledCode: false,
    };
  },
  created() {
    if (sessionStorage.getItem("unitAuth") && sessionStorage.getItem("token")) {
      this.$router.push({ name: "hospitalBuildList" });
    }
  },
  destroyed() {
    window.removeEventListener("scroll", this.isElementInViewport, true);
  },
  methods: {
    backLogin() {
      //忘记密码回到登录
      this.forgetData = {};
      this.forgetPwd = false;
    },
    checkPhone(val) {
      let mobile = /^[1][0-9]{10}$/;
      if (!mobile.test(val)) {
        return false;
      } else {
        return true;
      }
    },
    checkUser() {
      //忘记密码发送验证码之前监测用户是否为单位工作人员
      if (!this.checkPhone(this.forgetData.phone)) {
        return this.$message.warning("请输入正确的手机号码！");
      } else {
        // this.$db
        //   .post(this.$db.config.checkPhoneHas, { phone: this.forgetData.phone })
        //   .then(res => {
        // if (res.code == 200 && res.data) {
        this.sendSmsCode(this.forgetData);
        // }
        // });
      }
    },
    sendSmsCode(data) {
      if (!this.checkPhone(data.phone)) {
        return this.$message.warning("请输入正确的手机号码！");
      } else {
        var second = 60;
        var self = this;
        // 定时器
        var codeLimit = setInterval(function () {
          self.disabledCode = true;
          second--;
          self.codeText = second + "秒";
          if (second == 0) {
            clearInterval(codeLimit);
            self.disabledCode = false;
            self.codeText = "发送验证码";
          }
        }, 1000);
        this.$db
          .post(this.$db.config.sendCodeUrl, { mobile: data.phone })
          .then((res) => {
            if (res.code == 200) {
              return this.$message.success(res.msg);
            }
          });
      }
    },
    setNewPwd() {
      //修改密码操作

      if (
        !this.forgetData.phone ||
        !this.forgetData.code ||
        !this.forgetData.password ||
        !this.forgetData.password_two
      ) {
        return this.$message.warning("请填写完整账号信息！");
      } else {
        if (this.forgetData.password === this.forgetData.password_two) {
          this.$db
            .post(this.$db.config.submitForgetPwd, this.forgetData)
            .then((res) => {
              if (res.code == 200) {
                this.$message.success(res.msg);
                this.backLogin();
              }
            });
        } else {
          return this.$message.warning("您输入的两次密码不一致！");
        }
      }
    },

    unitLogin() {
      //单位登录
      if (!this.unitData.phone || !this.unitData.password) {
        return this.$message.warning("请填写登录信息！");
      } else {
        this.$db
          .post(this.$db.config.doUnitLoginUrl, {
            phone: this.unitData.phone,
            password: this.unitData.password,
          })
          .then((res) => {
            if (res && res.code == 200) {
              sessionStorage.setItem("token", res.data["access-token"]);
              this.getUserInfo();
            }
          });
      }
    },
    getUserInfo() {
      //根据token获取用户信息
      this.$db.post(this.$db.config.getUserInfoByToken, {}).then((res) => {
        if (res.code == 200) {
          let data = {};
          data = res.data;
          data.timestamp = new Date().getTime();

          let userInfo = JSON.stringify(data);
          sessionStorage.setItem("unitAuth", userInfo);
          sessionStorage.removeItem("unitChannelName");
          // practice_license
          //判断机构是否有机构代码证号 没有需要机构管理员补充
          if (
            !(res.data.practice_license && res.data.practice_license != "") &&
            res.data.type != 4
          ) {
            this.$message.warning(
              "您所在的单位需要补充机构代码证号，请联系单位管理员进行登录补充！"
            );
            sessionStorage.removeItem("token");
            sessionStorage.removeItem("unitAuth");
            return false;
          } else {
            if (res.data.audit_status === 0 || res.data.audit_status == 2) {
              this.$router.push({ name: "unitInfoSet" });
            } else {
              if (res.data.type == 1 || res.data.type == 3) {
                this.$router.push({ name: "hospitalComProjectList" });
              } else if (res.data.type == 2) {
                this.$router.push({ name: "cfProjectList" });
              } else if (res.data.type == 4) {
                if (
                  res.data.practice_license &&
                  res.data.practice_license != ""
                ) {
                  this.$router.push({ name: "hospitalComProjectList" });
                } else {
                  this.$router.push({ name: "unitInfoSet" });
                }
              } else {
                this.$message.warning(
                  "您的权限状态异常，请联系单位管理员重新分配权限！"
                );
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("unitAuth");
              }
            }
          }
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
#app-index {
  width: 100%;
}
.login-box {
  width: 100%;
  height: 655px;
  border-bottom: 1px solid #c30d23;
  background: url(../../assets/images/login_bg1.jpg) no-repeat;
  background-size: 100% 100%;
  position: relative;
  .login {
    width: 495px;
    min-height: 430px;
    background-color: #ffffff;
    box-shadow: 1px 1px 16px 0px rgba(11, 2, 5, 0.04);
    border-radius: 4px;
    border: solid 1px #ededed;
    position: absolute;
    top: 96px;
    right: 18%;
    .login-top {
      padding: 35px 63px 35px 63px;
      > ul {
        display: flex;
        justify-content: space-between;
        > li {
          list-style: none;
          padding-bottom: 6px;
          color: #999999;
          font-size: 20px;
          cursor: pointer;
          &.active {
            border-bottom: 2px solid #c30d23;
            color: #c30d23;
          }
        }
      }
    }
    .big-password {
      .btn-box {
        padding-top: 30px;
      }
    }
    .password-box {
      padding: 0 56px;
      .phone-box {
        border-bottom: 1px solid #ddd;
        justify-content: flex-start;
        margin-bottom: 26px;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #333;
          width: 80%;
          padding: 8px 0;
          padding-left: 15px;
        }
        > span {
          color: #333333;
          font-size: 20px;
          padding-right: 16px;
          border-right: 1px solid #ddd;
          position: relative;
          top: 1px;
        }
      }

      .input-box {
        display: flex;
        border-bottom: 1px solid #ddd;
        justify-content: space-between;
        margin-bottom: 26px;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #c0c0c0;
          width: 65%;
          padding: 8px 0;
          padding-left: 15px;
        }
        > button {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 20px;
          color: #4983bf;
          background-color: #fff;
          height: 38px;
          line-height: 38px;
          cursor: pointer;
        }
      }
    }
    .login-bottom {
      padding: 0 56px;
      .phone-box {
        border-bottom: 1px solid #ddd;
        justify-content: flex-start;
        margin-bottom: 50px;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #333;
          width: 80%;
          padding: 8px 0;
          padding-left: 15px;
        }
        > span {
          color: #333333;
          font-size: 20px;
          padding-right: 16px;
          border-right: 1px solid #ddd;
          position: relative;
          top: 1px;
        }
      }

      .input-box {
        display: flex;
        border-bottom: 1px solid #ddd;
        justify-content: space-between;
        > input {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 18px;
          color: #c0c0c0;
          width: 70%;
          padding: 8px 0;
          // padding-left: 15px;
        }
        > button {
          margin: 0;
          padding: 0;
          outline: none;
          border: none;
          font-size: 20px;
          color: #4983bf;
          background-color: #fff;
          height: 38px;
          line-height: 38px;
          cursor: pointer;
        }
      }
    }
    .btn-box {
      padding: 54px;
      > button {
        margin: 0;
        padding: 0;
        outline: none;
        border: none;
        width: 100%;
        padding: 14px 0;
        text-align: center;
        font-size: 20px;
        color: #ffffff;
        box-shadow: 2px 3px 10px 0px rgba(9, 1, 4, 0.21);
        border-radius: 6px;
        background-color: #c30d23;
        cursor: pointer;
      }
    }
  }
}
.login-foot {
  width: 100%;
  margin-bottom: 50px;
  .footer-box {
    width: 1300px;
    margin: 0 auto;
    padding: 26px 0;
    .f-top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 8px;
      &:last-child {
        margin-bottom: 0;
      }
      .top-l {
        > span {
          font-size: 14px;
          color: #707278;
          padding: 0 20px;
          border-right: 1px solid #707278;
          &:first-child {
            padding-left: 0;
          }
          &:last-child {
            border-right: none;
          }
        }
      }
      > p {
        font-size: 14px;
        color: #707278;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Login/unit_login.vue